import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { RepresentationTypes } from 'src/app/+models/shared.enums';
import { ModalComponent } from '../../common/modal/modal.component';

@Component({
  selector: 'app-profile-type-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslatePipe, ModalComponent],
  templateUrl: './profile-type-dialog.component.html',
  styleUrl: './profile-type-dialog.component.scss',
})
export class ProfileTypeDialogComponent {
  private translationKeyBase = 'registrationWizard.profileTypeModal.';
  private registrationTypesKey = 'profileTypes.';
  protected modalTitle = `${this.translationKeyBase}profileTypeToAdd`;
  protected selectedOption = RepresentationTypes.LEGAL_PERSON;
  protected dummyDate = new Date();

  protected registrationTypes = [
    {
      id: 'opt2',
      value: RepresentationTypes.LEGAL_PERSON,
      label: `${this.translationKeyBase}${this.registrationTypesKey}legalPerson`,
    },
    {
      id: 'opt3',
      value: RepresentationTypes.PROFESSIONAL_CLIENT,
      label: `${this.translationKeyBase}${this.registrationTypesKey}professionalClient`,
    },
  ];

  constructor(public activeModal: NgbActiveModal) {}

  protected handlePrimaryAction() {
    this.activeModal.close(this.selectedOption);
  }

  protected handleSecondaryAction() {
    this.activeModal.dismiss('canceled');
  }
}
